// import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { toggleSidebar } from '../../../store/actions/sidebar'
import { userSelector } from '../../../store/selectors/baseSelectors'
import { sidebarFolderSelector, sidebarCloseableSelector } from '../../../store/selectors/sidebarSelectors'

export default compose(
  connect(
    state => {
      const folder = !!sidebarFolderSelector(state)
      const user = userSelector(state)
      return {
        closeable: sidebarCloseableSelector(state),
        anon: user.isEmpty || user.isAnonymous,
        userName: user.displayName,
        inFolder: !!folder
      }
    },
    dispatch => ({
      toggleSidebar: () => dispatch(toggleSidebar())
    })
  )
)
